import { MaybeUndef } from '../../../types/system';
import { Action, Reducer } from '../../redux.types';

/**
 * Idea was taken from https://redux.js.org/recipes/structuring-reducers/reusing-reducer-logic
 * This wrapper filters out all actions with meta.componentId !== componentId
 * If action doesn't have meta it passes the filter
 */
export function createComponentOpenWrapperReducer<S, T, E>(
  reducerFunction: Reducer<S, T, E>,
  componentId: MaybeUndef<string>,
): Reducer<S, T, E> {
  return (state: S, action: Action, ...extra): S => {
    const { meta } = action;

    const isInitializationCall = state === undefined;

    if (isInitializationCall) {
      return reducerFunction(state, action);
    }

    if (meta && meta.componentId) {
      if (meta.componentId === componentId) {
        return reducerFunction(state, action, ...extra);
      }

      return state;
    }

    return reducerFunction(state, action, ...extra);
  };
}
